import {
  InstantAnswerBuilderFn,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { getOrderFulfillmentCTA } from "./shared";

export const Reimbursement: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: () =>
    reimbursementOfShippingCostBuilder(strictLocalize).getTitle(),
  descriptionBuilder: () =>
    reimbursementOfShippingCostBuilder(strictLocalize).getDescription(),
  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getOrderFulfillmentCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getOrderFulfillmentCTA(context, strictLocalize)?.getLink?.();
    },
  },
});

const reimbursementOfShippingCostBuilder = (
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () =>
      strictLocalize({
        defaultMessage: "Reimburse shipping costs when shipping on your own",
        description: {
          text: "Title for the answer of reimbursement of shipping cost issue",
        },
      }),
    getDescription: () => [
      strictLocalize({
        defaultMessage:
          "Ship on your own allows you to use your own carrier to ship orders, and we’ll reimburse the shipping cost on your payout up to an approved amount for those orders. You can add or update the shipping cost and tracking number in “Step 4. Shipping info” of the order fulfillment page once it’s available.",
      }),
    ],
  };
};
